import type { ReactNode } from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';

interface PickerMenuOptionProps {
    glyph: ReactNode;
    label: string;
    description?: string;
    labelClassName: string;
    selected: boolean;
    onPick: () => void;
}

export function PickerMenuOption({
    glyph,
    label,
    description,
    labelClassName,
    selected,
    onPick
}: PickerMenuOptionProps) {
    return (
        <button
            type="button"
            onClick={onPick}
            aria-current={selected || undefined}
            className="w-full flex items-center px-3 py-2 cursor-pointer hover:bg-gray-50 gap-2"
        >
            <span className="flex-shrink-0 flex items-center justify-center w-4 h-4">{glyph}</span>
            <span className="flex-1 text-left">
                <span className={`block text-[13px] font-semibold ${labelClassName}`}>{label}</span>
                {description && (
                    <span className="block text-[11px] text-gray-500">{description}</span>
                )}
            </span>
            {selected && <CheckIcon className="w-4 h-4 text-blue-600 flex-shrink-0" />}
        </button>
    );
}
